import { render, staticRenderFns } from "./PreviewButtonSettings.vue?vue&type=template&id=8b47b8bc"
import script from "./PreviewButtonSettings.vue?vue&type=script&lang=js"
export * from "./PreviewButtonSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports